<form [formGroup]="searchForm">
  <div>
    <mat-form-field>
      <mat-label>{{ "input-manufacturer" | translate }}</mat-label
      ><input
        type="text"
        matInput
        formControlName="name"
        [matAutocomplete]="auto"
        [required]="required"
      />
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        <mat-option disabled class="loading" *ngIf="loading">
          <mat-spinner diameter="25"></mat-spinner>
        </mat-option>
        <mat-option
          *ngFor="let partManufacturer of partManufacturers$ | async"
          (onSelectionChange)="
            handlePartManufacturerChange($event, partManufacturer)
          "
          [value]="partManufacturer.name"
          class="autocomplete"
        >
          {{ partManufacturer.name }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        *ngIf="
          searchForm.controls.name.touched &&
          searchForm.controls.name.hasError('required')
        "
        >{{ "required-manufacturer" | translate }}</mat-error
      >
    </mat-form-field>
  </div>
</form>
